<div class="dialog-select-file" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <span>{{'画像選択' | translate}}</span>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="selectFiles()">
          <mat-icon>add</mat-icon>
          <span>{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div fxLayout="row">
    <div class="supplement"
      [innerHTML]="'左側のチェックボックスから追加するファイルを選択し、右上の追加ボタンをクリックして追加します。<br>また、新規に画像ファイルを登録する場合は、ファイルをアップロードしてください。' | translate">
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center">
    <div class="dropzone" appDropzone (hovered)="toggleHover($event)" (dropped)="onDrop($event)"
      [class.hovering]="isHovering">
      <div class="body" fxLayout="column">
        <div class="title" fxLayout="row">
          {{'ファイル' | translate}}
          <mat-icon>publish</mat-icon>
        </div>
        <div class="file">
          <input type="file" (change)="onChangeFileInput($event)" multiple>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxLayoutGap="10px" style="padding-top: 8px;">
      <mat-form-field style="width: 250px;">
        <mat-label>{{'画像圧縮' | translate}}</mat-label>
        <mat-select [(value)]="compless" (selectionChange)="complessChange($event)" required>
          <mat-option value="1">{{'圧縮する（500KB以下へ）' | translate}}</mat-option>
          <mat-option value="2">{{'圧縮する（640px以下へ）' | translate}}</mat-option>
          <mat-option value="9">{{'圧縮しない' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 250px;">
        <mat-label>{{'属性' | translate}}</mat-label>
        <mat-select [(value)]="selectedAttributeId" (selectionChange)="onAttributeSelectionChange($event)">
          <mat-option [value]=""></mat-option>
          <mat-option *ngFor="let attr of uploadedFilesAttributes" [value]="attr.attribute_id">
            {{getAttributeName(attr.attribute_id)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div *ngFor="let file of files">
    <app-upload-task [file]="file" [compless]="compless" [type]="data.type ? 'DL' : ''" [attributeIds]="selectedAttributeId ? [selectedAttributeId] : []"></app-upload-task>
  </div>

  <div class="filter-field" fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex="25%">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
    </mat-form-field>
  </div>

  <div mat-dialog-content fxLayout="column" fxLayoutAlign="start center" fxFlex="500px" style="overflow: auto;">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let uploadedFile; let i = index"> {{ (i + 1) + (paginator.pageSize *
          paginator.pageIndex) }} </td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
          <span>{{'全' | translate}}</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="file">
        <th mat-header-cell *matHeaderCellDef>{{'画像' | translate}}</th>
        <td mat-cell *matCellDef="let uploadedFile">
          <img [src]="uploadedFile.download_url" height="40px" width="auto">
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'名称' | translate}}</th>
        <td mat-cell *matCellDef="let uploadedFile"> {{uploadedFile.file_name}} </td>
      </ng-container>

      <ng-container matColumnDef="attributes">
        <th mat-header-cell *matHeaderCellDef>{{'属性' | translate}}</th>
        <td mat-cell *matCellDef="let uploadedFile"> {{getAttributeNames(uploadedFile.attribute_ids)}} </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'登録日時' | translate}}
        </th>
        <td mat-cell *matCellDef="let uploadedFile"> {{ uploadedFile.created.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="download">
        <th mat-header-cell *matHeaderCellDef>{{'ダウンロード' | translate}}</th>
        <td mat-cell *matCellDef="let uploadedFile">
          <button mat-icon-button color="primary" (click)="downloadFile(uploadedFile)">
            <mat-icon>download</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>


</div>